import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    ReferenceField,
    DateField,
    NumberField,
    usePermissions,
    useResourceContext,
    Filter,
    SearchInput,
    SelectInput
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const PaymentFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SearchInput source='receipt_number' alwaysOn placeholder="Search by receipt number" />
        <SelectInput source='payment_mode' choices={[
            { id: 'cash', name: 'Cash' },
            { id: 'cheque', name: 'Cheque' },
            { id: 'online', name: 'Online' },
            { id: 'upi', name: 'UPI' },
            { id: 'card', name: 'Card' },
        ]} />
    </Filter>
);

export const FeePaymentList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    const propsObj = processPermissions(permissions, resource);
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Fee Payments" 
                {...props} 
                {...propsObj}
                filters={<PaymentFilter />}
                sort={{ field: 'payment_date', order: 'DESC' }}
            >
                <Datagrid rowClick={propsObj.hasShow ? 'show' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    <TextField source="id" />
                    <TextField source="receipt_number" label="Receipt #" />
                    <ReferenceField source="enrollment_id" reference="student-enrollment" label="Enrollment" link="show">
                        <TextField source="enrollment_number" />
                    </ReferenceField>
                    <NumberField source="amount" label="Amount" options={{ style: 'currency', currency: 'INR' }} />
                    <TextField source="payment_type" label="Payment Type" />
                    <TextField source="payment_mode" label="Payment Mode" />
                    <DateField source="payment_date" label="Payment Date" />
                    <TextField source="transaction_reference" label="Transaction Ref" />
                    <ReferenceField source="received_by" reference="user" label="Received By">
                        <TextField source="username" />
                    </ReferenceField>
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
